export default __webpack_public_path__ + "static/media/Snd_TryE.3c2e6cdf.mp3";